import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from 'reactstrap';

const PaymentDetails = (props) => {
  const {
    buttonLabel,
    className,
    feeDetails,
    paymentDetailsToggle,
    paymentDetailsModal,
  } = props;

  const {
    documentFee = 0,
    additionalFee = [],
    convenienceFee = 0,
  } = feeDetails;
let additionalTotal=0
  return (
    <div>
      <Button color="danger" onClick={paymentDetailsToggle}>
        {buttonLabel}
      </Button>
      <Modal
        isOpen={paymentDetailsModal}
        toggle={paymentDetailsToggle}
        className={className}
      >
        <ModalHeader toggle={paymentDetailsToggle}>Fee Details</ModalHeader>
        <ModalBody>
          <Table responsive hover>
            <thead>
              <tr>
                <th>Particulars</th>
                <th>Count</th>
                <th>Fee</th>
              </tr>
            </thead>
            <tbody>
              {documentFee && documentFee > 0 ? (
                <tr>
                  <td>Certificate Fee</td>
                  <td>-</td>
                  <td>${parseFloat(documentFee).toFixed(2)}</td>
                </tr>
              ) : (
                ""
              )}
              {additionalFee &&
                additionalFee.map(
                  ({ labelName, perAmount, totalCount, totalAmount }) => {
                    additionalTotal = additionalTotal + totalAmount;

                    return totalCount > 0 ? (
                      <>
                        <tr>
                          <td>{`$${perAmount} - ${labelName}`}</td>
                          <td>{totalCount}</td>
                          <td>${parseFloat(totalAmount).toFixed(2)}</td>
                        </tr>
                      </>
                    ) : (
                      <></>
                    );
                  }
                )}

              <tr>
                <td>Convenience Fee</td>
                <td>-</td>
                <td>
                  $
                  {parseFloat(
                    convenienceFee && convenienceFee > 0 ? convenienceFee : 0
                  ).toFixed(2)}
                </td>
              </tr>

              {/* <tr>
                                      <td>Convenience Fee</td>
                                      <td>-</td>
                                      <td>${parseFloat(convenienceFee).toFixed(2)}</td>
                                </tr>  */}
            </tbody>
            <tfoot>
              <tr>
                <td>Total Fee</td>
                <td></td>
                <td>
                  {/* {(
                    (parseFloat(String(totalFee).replace("$", "")) || 0) +
                    (parseFloat(String(convenienceFee).replace("$", "")) || 0) +
                    (parseFloat(String(documentFee).replace("$", "")) || 0)
                  ).toFixed(2)} */}
                  $
                  {(
                    (parseFloat(String(convenienceFee).replace("$", "")) || 0) +
                    (parseFloat(String(documentFee).replace("$", "")) || 0) +
                    (parseFloat(String(additionalTotal).replace("$", "")) || 0) 
                    
                  ).toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={paymentDetailsToggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PaymentDetails;
